import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: /api/BankOperation/sepamandat
 * Abrufen des SEPA-MAndats zu einem Kunden
 * Endpoints: /api/BankOperation/sepamandat
 */
export class GETbankoperationsepamandatApi extends BaseApiModel {
	constructor(initialProperties?: Partial<GETbankoperationsepamandatApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected token: string;
	/**
	 * Description: Token welcher ein verschlüsseltes Modell des Typs ADAC.Internet.Core.Models.Person.MemberTokenData enthält
	 * APIL Type: string
	 */
	get Token(): string {
		return this.token;
	}

	/**
	 * Description: Token welcher ein verschlüsseltes Modell des Typs ADAC.Internet.Core.Models.Person.MemberTokenData enthält
	 * APIL Type: string
	 */
	set Token(value: string) {
		this.token = value;
	}

	protected bankEinzugMitglied: boolean;
	/**
	 * Description: Kennung, ob der BankEinzug für die Mitgliedschaft zugelassen ist
	 * APIL Type: boolean
	 */
	get BankEinzugMitglied(): boolean {
		return this.bankEinzugMitglied;
	}

	/**
	 * Description: Kennung, ob der BankEinzug für die Mitgliedschaft zugelassen ist
	 * APIL Type: boolean
	 */
	set BankEinzugMitglied(value: boolean) {
		this.bankEinzugMitglied = value;
	}

	protected bankEinzugSchutzbrief: boolean;
	/**
	 * Description: Kennung, ob der BankEinzug für den Schutzbrief zugelassen ist
	 * APIL Type: boolean
	 */
	get BankEinzugSchutzbrief(): boolean {
		return this.bankEinzugSchutzbrief;
	}

	/**
	 * Description: Kennung, ob der BankEinzug für den Schutzbrief zugelassen ist
	 * APIL Type: boolean
	 */
	set BankEinzugSchutzbrief(value: boolean) {
		this.bankEinzugSchutzbrief = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): GETbankoperationsepamandatApi {
		return AppUtils.Helper.createFromMap(dataObject, GETbankoperationsepamandatApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Token = this.token;
		result.BankEinzugMitglied = this.bankEinzugMitglied;
		result.BankEinzugSchutzbrief = this.bankEinzugSchutzbrief;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}